/**
 * paymentSettingsSlice — Payment settings (Invoice Generation + Reminders).
 *
 * Hydrated from the live payment-settings API via PaymentSettingsInitializer
 * (seeded server-side by `getPaymentSettingsSSR()`); the forms seed their local
 * state from here and dispatch `setPaymentSettings` with the server-returned
 * value on save (mirrors `bookingSettingsSlice`).
 */
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import {
  defaultPaymentSettings,
  type PaymentSettings,
} from "@/components/settings/payment/types";

export interface PaymentSettingsState {
  settings: PaymentSettings;
  loading: boolean;
}

const initialState: PaymentSettingsState = {
  settings: defaultPaymentSettings(),
  loading: true,
};

const paymentSettingsSlice = createSlice({
  name: "paymentSettings",
  initialState,
  reducers: {
    /** Replace the payment settings — used to hydrate on mount. */
    setPaymentSettings(state, action: PayloadAction<PaymentSettings>) {
      state.settings = action.payload;
    },
    setPaymentLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
});

export const { setPaymentSettings, setPaymentLoading } =
  paymentSettingsSlice.actions;

export default paymentSettingsSlice.reducer;
